import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const StyledTags = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;

  .tag a {
    border-bottom: 2px solid var(--primary);
    cursor: pointer;
  }

  .tag a,
  .tag div {
    text-transform: uppercase;
    text-decoration: none;
    color: var(--primary);
  }

  .tag {
    padding-right: 2rem;
    border-right: 2px solid var(--black);
  }

  .tag:last-child {
    padding: 0;
    border: none;
  }

  @media only screen and (max-width: ${(props) => (props.breakpoint ? props.breakpoint : '525')}px) {
    gap: 2.25rem;
    flex-direction: column;

    .tag {
      border: none;
      padding: 0;
      text-align: center;
    }
  }
`;

const Tags = ({ tags, breakpoint }) => {
  return (
    <StyledTags className="tags body-l-semibold" breakpoint={breakpoint}>
      {tags.map((tag) => {
        return (
          <li className="tag">
            {tag.link ? <Link to={tag.link}>{tag.text}</Link> : <div>{tag.text}</div>}
          </li>
        );
      })}
    </StyledTags>
  );
};

export default Tags;
